import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import ExampleMob from './example-mob.svg'
import ExampleDesk from './example-desk.svg'
import IntegrationsMob from './integrations-mob.svg'
import IntegrationsDesk from './integrations-desk.svg'
import classes from './DataIntegrationFramework.module.scss'

export const DataIntegrationFrameWork = () => {
  return (
    <div className={classes.wrapper}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Connector framework flexible enough for all your needs
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Our open connector framework lets you access data and metadata in every
        external API in a consistent way.
      </Text>
      <div className={classes.wrap}>
        <Picture
          className={classes.imageFirst}
          mobSvg={ExampleMob.src}
          deskSvg={ExampleDesk.src}
          deskBreakpoint={992}
          alt='Your Product'
          lazyLoad
        />
        <div className={classes.content}>
          <Text as={'span'} size={'md'} className={classes.contentCaption}>
            Connector Framework
          </Text>
          <div className={classes.contentInner}>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>
                Universal Data Models
              </span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Events</span>
              <span className={classes.contentText}>Global Webhooks</span>
              <span className={classes.contentText}>User Webhooks</span>
              <span className={classes.contentText}>Polling</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Data Collections</span>
              <span className={classes.contentText}>CRUD</span>
              <span className={classes.contentText}>Schema</span>
              <span className={classes.contentText}>References</span>
              <span className={classes.contentText}>Custom Fields</span>
              <span className={classes.contentText}>Change Events</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Operations</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Authentication</span>
            </div>
          </div>
        </div>
        <Picture
          className={classes.imageLast}
          mobSvg={IntegrationsMob.src}
          deskSvg={IntegrationsDesk.src}
          deskBreakpoint={992}
          alt='Integrations'
          lazyLoad
        />
      </div>
      {/* <Link
        type='secondary'
        className={classes.link}
        href={CONNECTOR_DOCS_LINK}
      >
        Learn more about connector framework
      </Link> */}
    </div>
  )
}
